var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_9181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5653 12.8194H3.61971C2.4229 12.8194 1.44922 11.8458 1.44922 10.649V3.70339C1.44922 2.50658 2.4229 1.5329 3.61971 1.5329H10.5653C11.7621 1.5329 12.7358 2.50658 12.7358 3.70339V10.649C12.7358 11.8458 11.7621 12.8194 10.5653 12.8194Z",
    fill: "url(#paint0_linear_1389_9181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 6.99841C10.4031 6.20345 10.0363 5.54736 9.42735 5.0317C8.78714 4.47887 8.00711 4.20221 7.08732 4.20221C6.16727 4.20221 5.38729 4.47572 4.7474 5.02215C4.13814 5.54465 3.77463 6.20345 3.65668 6.99841C3.63169 7.12906 3.61914 7.25334 3.61914 7.37165C3.61914 7.89373 3.78999 8.35027 4.13211 8.74201C4.47376 9.13351 4.9555 9.41975 5.57729 9.59944V9.73988C5.57729 9.91368 5.6362 10.0598 5.75427 10.1778C5.87221 10.296 6.01833 10.3613 6.19239 10.3737C6.37264 10.3863 6.50608 10.3551 6.59316 10.2805C6.72978 10.3797 6.88214 10.4294 7.05007 10.4294C7.20542 10.4294 7.34852 10.383 7.47882 10.2898C7.56596 10.3579 7.69322 10.3863 7.8612 10.3737C8.03507 10.3551 8.1813 10.2882 8.2993 10.1733C8.41732 10.0578 8.4763 9.9137 8.4763 9.73988V9.63741C9.14744 9.46316 9.66649 9.17118 10.0334 8.76053C10.3876 8.36923 10.5647 7.90635 10.5647 7.37165C10.5647 7.25334 10.5522 7.12906 10.5273 6.99841ZM6.28561 7.89825C6.09908 8.11293 5.87516 8.21983 5.61436 8.21983C5.35338 8.21983 5.12959 8.11296 4.94314 7.89825C4.75671 7.68386 4.6634 7.42416 4.6634 7.11961C4.6634 6.8153 4.75671 6.55568 4.94314 6.34171C5.12959 6.12737 5.35338 6.02016 5.61436 6.02016C5.87516 6.02016 6.09908 6.12737 6.28561 6.34171C6.47214 6.55568 6.56556 6.8153 6.56556 7.11961C6.56553 7.42416 6.47214 7.68381 6.28561 7.89825ZM7.09653 9.13351C6.94112 9.13351 6.82615 9.09349 6.75172 9.01386C6.70813 8.96416 6.68656 8.90299 6.68656 8.82904C6.68656 8.71254 6.73152 8.59581 6.82165 8.47873C6.91171 8.36226 7.00013 8.30386 7.08732 8.30386C7.17435 8.30386 7.25643 8.36826 7.33426 8.49788C7.41192 8.62683 7.45109 8.74945 7.45109 8.86653C7.45109 9.0448 7.33276 9.13351 7.09653 9.13351ZM9.15228 7.89825C8.96889 8.11293 8.74368 8.21983 8.47628 8.21983C8.2154 8.21983 7.99327 8.11296 7.80992 7.89825C7.62636 7.68386 7.53465 7.42416 7.53465 7.11961C7.53465 6.8153 7.62636 6.55568 7.80992 6.34171C7.99327 6.12737 8.2154 6.02016 8.47628 6.02016C8.74368 6.02016 8.96896 6.12737 9.15228 6.34171C9.33547 6.55568 9.42735 6.8153 9.42735 7.11961C9.42737 7.42416 9.33547 7.68381 9.15228 7.89825Z",
    fill: "url(#paint1_linear_1389_9181)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9181",
    x1: 7.09249,
    y1: 1.66009,
    x2: 7.09249,
    y2: 8.56529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#2367EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#294CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9181",
    x1: 7.09192,
    y1: 4.20221,
    x2: 7.09192,
    y2: 7.75497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_9181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8911,
    height: 13.8911,
    fill: "white",
    transform: "translate(0.146484 0.230591)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon2);
export default __webpack_public_path__ + "static/media/camera_card_icon2.1be8644d13660dc70d6d06c9f09f3e0f.svg";
export { ForwardRef as ReactComponent };